document.addEventListener("alpine:init", () => {
  Alpine.data("SubscriptionWidget", () => ({
    product: null,
    selected_variant: null,
    mf_weight: "",
    mf_per_bath: "",
    price_per_bottle_regular: "",
    price_per_bath: "",
    selling_plans: [],
    sv_subscription_save_from_compare: false,
    _otpPriceHtml: "",
    _otpBadgeHtml: "",
    _otpHadOnSale: false,
    sv_save_html_template: "",
    selected: {
      type: "subscribe", // 'one-time' or 'subscribe'
      frequency: "",
      plan: null,
      quantity: 1
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
      this.$nextTick(() => {
        this.u_CaptureOtpPriceHtml();
        this.u_SyncProductPrices();
      });
    },
    InitSelf() {
      let product = JSON.parse(this.$el.dataset.product);
      this.product = product;
      this.selected_variant = JSON.parse(this.$el.dataset.selected_variant);
      this.sv_subscription_save_from_compare =
        this.$el.dataset.svSubscriptionSaveFromCompare === "true";
      this.sv_save_html_template = this.$el.dataset.svSaveHtml || "";

      this.mf_weight = parseFloat(this.$el.dataset.mf_weight);
      this.mf_per_bath = parseFloat(this.$el.dataset.mf_per_bath);
      this.mf_bottles = parseInt(this.$el.dataset.mf_bottles);
      this.price_per_bottle_regular = parseFloat(this.$el.dataset.mf_per_bottle_price);

        // Parse first_order_discount if present (only for pdp-test-03)
        this.first_order_discount = 0;
        if (this.$el.dataset.firstOrderDiscount !== undefined) {
          let fod = Number(this.$el.dataset.firstOrderDiscount);
          if (!isNaN(fod) && fod > 0) {
            this.first_order_discount = fod;
          }
        }

      this.RebuildSellingPlans();
    },
    RebuildSellingPlans(preserveSellingPlanId) {
      let allowed_groups = this.product.selling_plan_groups.filter(
        (g) =>
          g.app_id == "SKIO" &&
          !g.name.toLowerCase().includes("hidden-") &&
          !g.name.toLowerCase().includes("dynamic box subscription")
      );
      let allowed_plans = allowed_groups.flatMap((g) => g.selling_plans);

      let selling_plans = this.selected_variant.selling_plan_allocations
        .filter((item) => allowed_plans.some((p) => p.id == item.selling_plan_id))
        .map((item) => {
          let plan = allowed_plans.find((p) => p.id == item.selling_plan_id);
          let options = plan.options.map((opt, i) =>
            i === 0 ? { ...opt, value: opt.value.replace(/^Delivered every /i, "") } : opt
          );
          return { ...item, ...plan, options };
        });

      this.selling_plans = selling_plans;

      if (allowed_groups.length > 0 && allowed_groups[0].selling_plans[0]?.price_adjustments?.[0]) {
        this.subscription_discount = allowed_groups[0].selling_plans[0].price_adjustments[0].value;
      }

      if (!selling_plans.length) {
        this.selected.plan = null;
        this.selected.frequency = "";
        return;
      }

      let planToSelect;
      if (preserveSellingPlanId && selling_plans.some((p) => p.selling_plan_id == preserveSellingPlanId)) {
        planToSelect = selling_plans.find((p) => p.selling_plan_id == preserveSellingPlanId);
      } else {
        const rawIdx = this.$el.getAttribute("data-selected_frequency_index");
        const idx = parseInt(rawIdx, 10);
        planToSelect = selling_plans[Number.isFinite(idx) ? idx : 0] || selling_plans[0];
      }
      this.selected.plan = planToSelect;
      this.selected.frequency = planToSelect.selling_plan_id;
    },
    InitWatchers() {
      let $product = this.$el.closest(".product__info-container");
      let $quantity = $product.querySelector("[name=quantity]");
      if ($quantity) {
        $quantity.addEventListener("change", (e) => {
          this.selected.quantity = parseInt(e.target.value);
          this.u_SyncProductPrices();
        });
      }

      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        let productInfo = this.$el.closest("product-info");
        if (!productInfo || productInfo.dataset.section !== e.data.sectionId) return;
        let v = e.data.variant;
        if (!v) return;
        let prevPlanId = this.selected.frequency;
        this.selected_variant = v;
        this.RebuildSellingPlans(prevPlanId);
        this.$nextTick(() => {
          this.u_CaptureOtpPriceHtml();
          this.u_SyncProductPrices();
        });
      });

      this.$watch("selected.frequency", () => {
        let plan = this.selling_plans.find((plan) => plan.selling_plan_id == this.selected.frequency);
        this.selected.plan = plan;
      });

      this.$watch("selected.type", () => this.u_SyncProductPrices());
      this.$watch("selected.quantity", () => this.u_SyncProductPrices());
      this.$watch("selected.plan", () => this.u_SyncProductPrices());
    },
    u_GetSectionId() {
      return this.$el.closest("product-info")?.dataset?.section;
    },
    u_GetMainPriceContainer() {
      return this.$el.closest(".product__info-container")?.querySelector(".product__price .price__container");
    },
    u_GetMainPriceRoot() {
      return this.$el.closest(".product__info-container")?.querySelector(".product__price .price");
    },
    u_GetPriceRoots() {
      let roots = [];
      let main = this.u_GetMainPriceRoot();
      if (main) roots.push(main);
      let sectionId = this.u_GetSectionId();
      if (sectionId) {
        let sticky = document.getElementById(`sticky-atc-${sectionId}`)?.querySelector(".product__price .price");
        if (sticky) roots.push(sticky);
      }
      return roots;
    },
    u_CaptureOtpPriceHtml() {
      let el = this.u_GetMainPriceContainer();
      if (el) this._otpPriceHtml = el.innerHTML;
      let priceRoot = this.u_GetMainPriceRoot();
      if (priceRoot) {
        this._otpHadOnSale = priceRoot.classList.contains("price--on-sale");
        let badge = priceRoot.querySelector(".price__badge-sale");
        this._otpBadgeHtml = badge ? badge.innerHTML : "";
      }
    },
    u_OneTimePriceTotal() {
      if (!this.selected_variant) return 0;
      return this.selected_variant.price * this.selected.quantity;
    },
    u_OneTimeHasSavings() {
      let v = this.selected_variant;
      return !!(v && v.compare_at_price && v.compare_at_price > v.price);
    },
    u_OneTimeSavingAmountCents() {
      if (!this.u_OneTimeHasSavings()) return 0;
      return Math.max(0, this.u_SubscribeCompareBaselineTotal() - this.u_OneTimePriceTotal());
    },
    u_SubscribeSavingAmountCents() {
      return Math.max(0, this.u_SubscribeSavingStrikeTotal() - this.u_SubscribeSubscriptionTotal());
    },
    u_BuildSaveBadgeText(amountCents) {
      let amount = this.u_FormatMoney(amountCents);
      let template = this.sv_save_html_template || "Save SAVE_AMOUNT_PLACEHOLDER";
      return template.replace("SAVE_AMOUNT_PLACEHOLDER", amount);
    },
    u_BuildSalePriceHtml(strikeCents, priceCents) {
      let strike = this.u_FormatMoney(strikeCents);
      let price = this.u_FormatMoney(priceCents);
      return `<div class="price__subscription"><s class="price-item price-item--regular">${strike}</s><span class="price-item price-item--sale">${price}</span></div>`;
    },
    u_BuildSubscribePriceHtml() {
      if (this.selected.type !== "subscribe" || !this.selected.plan) return null;
      return this.u_BuildSalePriceHtml(this.u_SubscribeSavingStrikeTotal(), this.u_SubscribeSubscriptionTotal());
    },
    u_BuildOneTimePriceHtml() {
      if (!this.selected_variant) return "";
      let priceTotal = this.u_OneTimePriceTotal();
      if (this.u_OneTimeHasSavings()) {
        return this.u_BuildSalePriceHtml(this.u_SubscribeCompareBaselineTotal(), priceTotal);
      }
      return `<div class="price__subscription"><span class="price-item price-item--sale">${this.u_FormatMoney(priceTotal)}</span></div>`;
    },
    u_BuildPriceContainerHtml() {
      if (this.selected.type === "subscribe" && this.selected.plan) {
        return this.u_BuildSubscribePriceHtml();
      }
      return this.u_BuildOneTimePriceHtml();
    },
    u_GetSaveBadgeText() {
      if (this.selected.type === "subscribe" && this.selected.plan) {
        return this.u_BuildSaveBadgeText(this.u_SubscribeSavingAmountCents());
      }
      if (this.u_OneTimeHasSavings()) {
        return this.u_BuildSaveBadgeText(this.u_OneTimeSavingAmountCents());
      }
      return null;
    },
    u_ShouldShowSaleBadge() {
      if (this.selected.type === "subscribe" && this.selected.plan) return true;
      return this.u_OneTimeHasSavings();
    },
    u_SyncPriceBadge() {
      let showSale = this.u_ShouldShowSaleBadge();
      let saveText = this.u_GetSaveBadgeText();
      this.u_GetPriceRoots().forEach((priceRoot) => {
        let badge = priceRoot.querySelector(".price__badge-sale");
        if (showSale) {
          priceRoot.classList.add("price--on-sale");
          if (badge && saveText) badge.textContent = saveText;
        } 
        else {
          if (badge) badge.innerHTML = '';
        }
      });
    },
    u_SyncProductPrices() {
      let isSubscribe = this.selected.type === "subscribe" && this.selected.plan;
      let content = this.u_BuildPriceContainerHtml() || this._otpPriceHtml;
      if (!content) return;
      let el = this.u_GetMainPriceContainer();
      if (el) el.innerHTML = content;
      this.u_SyncPriceBadge();
      document.dispatchEvent(
        new CustomEvent("sticky-atc:update", {
          detail: {
            priceContainerHtml: content,
            isSubscribe: isSubscribe,
            showSaleBadge: this.u_ShouldShowSaleBadge(),
            saveBadgeText: this.u_GetSaveBadgeText(),
            strikeTotal: isSubscribe ? this.u_SubscribeSavingStrikeTotal() : this.u_SubscribeCompareBaselineTotal(),
            subscriptionTotal: isSubscribe ? this.u_SubscribeSubscriptionTotal() : this.u_OneTimePriceTotal(),
            otpHadOnSale: this._otpHadOnSale,
            otpBadgeHtml: this._otpBadgeHtml,
            selected: this.selected,
            selected_variant: this.selected_variant
          }
        })
      );
    },
    u_SubscribeCompareBaselineUnitCents() {
      let v = this.selected_variant;
      if (!v) return 0;
      if (v.compare_at_price && v.compare_at_price > 0) return v.compare_at_price;
      return v.price;
    },
    u_SubscribeCompareBaselineTotal() {
      return this.u_SubscribeCompareBaselineUnitCents() * this.selected.quantity;
    },
    u_SubscribeSubscriptionTotal() {
      if (!this.selected.plan) return 0;
      if (this.first_order_discount && this.first_order_discount > 0) {
        return this.selected.plan.per_delivery_price * this.selected.quantity - (this.selected.plan.per_delivery_price * this.selected.quantity * this.first_order_discount / 100);
      }
      return this.selected.plan.per_delivery_price * this.selected.quantity;
    },
    u_SubscribeSavePercent() {
      let base = this.u_SubscribeCompareBaselineTotal();
      let sub = this.u_SubscribeSubscriptionTotal();
      if (base <= 0) return 0;
      return Math.max(0, Math.round(((base - sub) / base) * 100));
    },
    u_HasCompareAtBaseline() {
      let v = this.selected_variant;
      return !!(v && v.compare_at_price && v.compare_at_price > 0);
    },
    u_SubscribeSavingStrikeTotal() {
      if (this.u_HasCompareAtBaseline()) {
        return this.u_SubscribeCompareBaselineTotal();
      }
      if (!this.selected_variant) return 0;
      return this.selected_variant.price * this.selected.quantity;
    },
    u_SubscribeSavingSavePercent() {
      let strike = this.u_SubscribeSavingStrikeTotal();
      let sub = this.u_SubscribeSubscriptionTotal();
      if (strike <= 0) return 0;
      return Math.max(0, Math.round(((strike - sub) / strike) * 100));
    },
    u_GetPricePerBath(selected_type) {
      let price =
        selected_type === "subscribe"
          ? this.selected.plan && this.selected.plan.per_delivery_price
          : this.selected_variant && this.selected_variant.price;
      if (!price || !this.mf_weight || !this.mf_per_bath) return 0;
      return price / this.mf_weight / this.mf_per_bath;
    },
    u_GetPricePerBottle(selected_type) {
      let price =
        selected_type === "subscribe" ? this.selected.plan.per_delivery_price : this.selected_variant.price;
      let bottles_count = this.mf_bottles;
      let per_bottle = price / bottles_count / 100;
      let per_bottle_regular = this.price_per_bottle_regular / 100;
      let saving = per_bottle_regular - per_bottle;
      return selected_type === "subscribe" ? saving : per_bottle;
    },
    u_FormatMoney(value) {
      return formatMoney(value, theme.settings.money_with_currency_format);
    },
    u_FormatFrequencyOption(value) {
      if (!value) return "Every";
      let normalized = String(value).trim().replace(/^every\s+/i, "");
      let words = normalized.split(/\s+/);
      let formatted = words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
      return `Every ${formatted}`;
    },
    e_HandleFrequencyChange(e) {
      let plan = this.selling_plans.find((plan) => plan.selling_plan_id == e.target.value);
      this.selected.plan = plan;
    }
  }));

  Alpine.data("ProductMediaGallery", () => ({
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        let variant = e.data.variant;
        this.LoadVariantImages(variant);
      });
    },
    async LoadVariantImages(variant) {
      if (!variant) return;
      let section_id = this.$el.dataset.section_id;
      let url = `${window.location.pathname}?variant=${variant.id}&section_id=${section_id}`;
      let response = await fetch(url);
      let data = await response.text();
      let html = new DOMParser().parseFromString(data, "text/html");
      let $gallery = html.querySelector("media-gallery gallery-carousel");
      if ($gallery) {
        // Replace the current gallery with the new one
        this.$el.querySelector("gallery-carousel").replaceWith($gallery);
        document.dispatchEvent(new Event("gallery:refresh"));
      }
    }
  }));

  Alpine.data("BundleSticky", () => ({
    opened: false,

    toggleSticky() {
      this.opened = !this.opened;
    }
  }));

  Alpine.data("BundleSubscription", () => ({
    showModal: false,

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleBackdropClick(event) {
      if (!this.$refs.modalContent.contains(event.target)) {
        this.closeModal();
      }
    }
  }));

  Alpine.data("VariantInfo", () => ({
    showModal: false,

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleBackdropClick(event) {
      if (!this.$refs.modalContent.contains(event.target)) {
        this.closeModal();
      }
    }
  }));

  Alpine.data("BundleProductMedia", () => ({
    showAlter: false,

    showAlterImage() {
      this.showAlter = true;
    },
    hideAlterImage() {
      this.showAlter = false;
    }
  }));

  Alpine.data("BundleBuilder", () => ({
    product: null,
    selected_variants: [],
    total_price: 0,
    min_quantity: 3,
    bundle_price: 0,
    bundle_quantity: 0,
    bundle_discount: 10, // Assuming a fixed 10% discount for the bundle
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      this.$watch("selected_variants", () => {
        // Update total quantity and price whenever selected_variants changes
        let total_quantity = this.selected_variants.reduce((total, variant) => {
          return total + variant.quantity;
        }, 0);
        this.bundle_quantity = total_quantity;

        let total_price = this.selected_variants.reduce((total, variant) => {
          return total + variant.price * variant.quantity;
        }, 0);
        this.total_price = total_price;
        this.bundle_price = total_price * (1 - this.bundle_discount / 100);
      });
    },
    e_UpdateBundleVariants(e) {
      this.$nextTick(() => {
        let $variant = this.$el;
        let variant = JSON.parse($variant.dataset.variant);
        variant.quantity = parseInt(
          $variant.querySelector(".skio-bundle-product__quantity-display").textContent
        );

        let variant_exists = this.selected_variants.find((v) => v.id === variant.id);
        if (variant_exists) {
          // If variant already exists, update its quantity
          variant_exists.quantity = variant.quantity;
        } else {
          // If variant does not exist, add it to the array
          this.selected_variants.push(variant);
        }
      });
    },
    u_FormatMoney(value) {
      return formatMoney(value, theme.settings.money_with_currency_format);
    }
  }));

  Alpine.data("StickyAddToCart", () => ({
    selected_variant: null,
    strikeTotal: 0,
    subscriptionTotal: 0,
    selected: {
      type: "subscribe", // 'one-time' or 'subscribe'
      frequency: "",
      plan: null,
      quantity: 1
    },
    init() {
      this.InitWatchers();
    },
    u_FormatMoney(value) {
      return formatMoney(value, theme.settings.money_with_currency_format);
    },
    u_UpdateStickyNotePrices() {
      let strikeEl = this.$el.querySelector("[data-sticky-strike-price]");
      let subEl = this.$el.querySelector("[data-sticky-sub-price]");
      if (strikeEl) strikeEl.textContent = this.u_FormatMoney(this.strikeTotal);
      if (subEl) subEl.textContent = this.u_FormatMoney(this.subscriptionTotal);
    },
    InitWatchers() {
      document.addEventListener("sticky-atc:update", (e) => {
        if (e.detail.selected) this.selected = { ...e.detail.selected };
        if (e.detail.selected_variant) this.selected_variant = { ...e.detail.selected_variant };
        if (e.detail.strikeTotal != null) this.strikeTotal = e.detail.strikeTotal;
        if (e.detail.subscriptionTotal != null) this.subscriptionTotal = e.detail.subscriptionTotal;
        this.$nextTick(() => {
          this.u_UpdateStickyNotePrices();
          let priceRoot = this.$el.querySelector(".product__price .price");
          let price_element = priceRoot?.querySelector(".price__container");
          if (price_element && e.detail.priceContainerHtml) {
            price_element.innerHTML = e.detail.priceContainerHtml;
          }
          let badge = priceRoot?.querySelector(".price__badge-sale");
          if (e.detail.showSaleBadge) {
            priceRoot?.classList.add("price--on-sale");
            if (badge && e.detail.saveBadgeText) badge.textContent = e.detail.saveBadgeText;
          } else {
            priceRoot?.classList.toggle("price--on-sale", !!e.detail.otpHadOnSale);
            if (badge && e.detail.otpBadgeHtml !== undefined) badge.innerHTML = e.detail.otpBadgeHtml;
          }
        });
      });
    }
  }));

  Alpine.data("BathtimeAddons", () => ({
    swiper: null,
    isMobileNative: false,
    errorMessage: "",
    errorTimeout: null,
    slideCount: 0,
    swiperRetryCount: 0,

    init() {
      this.slideCount = parseInt(this.$el.dataset.slideCount, 10) || 0;
      this.$nextTick(() => {
        this.initSwiperWithRetry();
      });
    },

    initSwiperWithRetry() {
      if (typeof Swiper !== "undefined") {
        this.initSwiper();
        return;
      }

      if (this.swiperRetryCount < 20) {
        this.swiperRetryCount += 1;
        setTimeout(() => this.initSwiperWithRetry(), 50);
        return;
      }

      this.enableNativeFallback();
    },

    initSwiper() {
      const root = this.$refs.sliderRoot;
      if (!root) return;

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      const nextArrow = this.$refs.nextArrow;
      const prevArrow = this.$refs.prevArrow;

      try {
        this.swiper = new Swiper(root, {
          slidesPerView: 3.5,
          spaceBetween: 12,
          speed: 400,
          loop: false,
          watchOverflow: true,
          breakpoints: {
            641: {
              slidesPerView: 4,
              spaceBetween: 14,
            },
          },
          ...(nextArrow && prevArrow
            ? {
                navigation: {
                  nextEl: nextArrow,
                  prevEl: prevArrow,
                  disabledClass: "swiper-button-disabled",
                },
              }
            : {}),
          on: {
            init(swiper) {
              if (swiper.navigation) swiper.navigation.update();
            },
            slideChange(swiper) {
              if (swiper.navigation) swiper.navigation.update();
            },
          },
        });
      } catch (e) {
        console.error(e);
        this.enableNativeFallback();
      }
    },

    enableNativeFallback() {
      this.isMobileNative = true;
      const root = this.$refs.sliderRoot;
      if (root) root.classList.add("s--bathtime-addons__slider--native-fallback");
    },

    getCart() {
      return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    },

    setButtonLoading(button, isLoading) {
      if (!button) return;
      const spinner = button.querySelector(".loading__spinner");
      if (isLoading) {
        button.setAttribute("aria-disabled", "true");
        button.classList.add("loading");
        if (spinner) spinner.classList.remove("hidden");
      } else {
        button.classList.remove("loading");
        button.removeAttribute("aria-disabled");
        if (spinner) spinner.classList.add("hidden");
      }
    },

    showError(message) {
      this.errorMessage = message;
      if (this.errorTimeout) clearTimeout(this.errorTimeout);
      this.errorTimeout = setTimeout(() => {
        this.clearError();
      }, 5000);
    },

    clearError() {
      this.errorMessage = "";
      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
        this.errorTimeout = null;
      }
    },

    renderCartContents(response) {
      const cart = this.getCart();
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }
      cart.renderContents(response);
      if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "bathtime-addons",
          cartData: response,
        });
      }
    },

    async requestSingleAdd(variantId) {
      const cart = this.getCart();
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      if (cart) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id).join(",")
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      return response.json();
    },

    async addVariant(variantId, event) {
      const button = event.currentTarget;
      if (button.getAttribute("aria-disabled") === "true") return;

      this.setButtonLoading(button, true);
      this.clearError();

      try {
        const response = await this.requestSingleAdd(variantId);
        if (response.status) {
          this.showError(response.description || response.message || "Unable to add item.");
          return;
        }
        this.renderCartContents(response);
      } catch (e) {
        console.error(e);
        this.showError("Unable to add item.");
      } finally {
        this.setButtonLoading(button, false);
      }
    },
  }));
});
